(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'peopleList', {
            bindings: {
                content:    '<',
            },
            templateUrl: 'app/views/partials/content/people-list.html',
            controller: PeopleListController,
            controllerAs: 'vm',

            renderingOptions: {
                'contact-block-teaching-staff': {
                    inputs:    [
                        'content="::content.asset_contents"'
                    ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd: '</div>',
                    classes: [
                        'block',
                        'content-simple'
                    ]
                }
            }
        });


    function PeopleListController(
        $scope,
        Utils,
        TEXTS
    ){
        // Helper members.

        /** @type {angular.IController} */
        var vm = this;


        /** Expose to the Scope. */

        $scope._ = TEXTS.GENERIC.STAFF_LIST;


        /** @constructor */
        vm.$onInit = function() {
            // Methods
            vm.constructAnchor = Utils.anchorConstructorFactory( vm, 'content', 'heading' );
        }
    }


    PeopleListController.$inject = [ '$scope', 'Utils', 'TEXTS' ];
})();
